import { shallowRef } from "vue";

export const modalRef = shallowRef(null);

export function openModal({ title, component, props, onConfirm, onCancel }) {
  if (modalRef.value) {
    modalRef.value.open({ title, component, props, onConfirm, onCancel });
  }
}

export function closeModal() {
  if (modalRef.value) {
    modalRef.value.close();
  }
}
